import { TAssetsSvgMapValue } from '@libs/types';
import clsx from 'clsx';
import React, { useEffect } from 'react';
import { ButtonCircleView } from '../../Buttons/ButtonCircleView';
import { NavBar } from '../NavBar/NavBar';
import styles from './modal.module.css';

type TModalProps = (
    | {
          isCanCloseModal: true;
          onHandleClick: () => void;
      }
    | {
          isCanCloseModal: false;
      }
) & {
    children: React.ReactNode;
    iconName?: TAssetsSvgMapValue;
    isVerticalCentered?: boolean;
    noTopPadding?: boolean;
    /** Version of the widget that opened the modal (`TWidget.version`): the modal chrome follows its design. */
    version: number | undefined;
};
const Modal = ({ ...props }: TModalProps) => {
    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'visible';
        };
    }, []);

    return (
        <div className={styles.modalContainer} id="portal-modal">
            <div className={styles.modalViewport}>
                <div
                    id="portal-modal-content"
                    className={clsx(styles.modalBody, props.noTopPadding && styles.noTopPadding, props.isVerticalCentered && styles.isVerticalCentered)}
                >
                    {props.children}
                </div>
                {props.isCanCloseModal && (
                    <NavBar dataTest={'close-modal'} align="space-between">
                        <ButtonCircleView version={props.version} iconName={props.iconName} iconWidth={24} iconHeight={24} onClick={props.onHandleClick} />
                    </NavBar>
                )}
            </div>
        </div>
    );
};
export { Modal };
